/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} User_Profile_Danger_Zone_SubtitleInputs */

const es_user_profile_danger_zone_subtitle = /** @type {(inputs: User_Profile_Danger_Zone_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acciones irreversibles y destructivas`)
};

const en_user_profile_danger_zone_subtitle = /** @type {(inputs: User_Profile_Danger_Zone_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Irreversible and destructive actions`)
};

/**
* | output |
* | --- |
* | "Irreversible and destructive actions" |
*
* @param {User_Profile_Danger_Zone_SubtitleInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const user_profile_danger_zone_subtitle = /** @type {((inputs?: User_Profile_Danger_Zone_SubtitleInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<User_Profile_Danger_Zone_SubtitleInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_user_profile_danger_zone_subtitle(inputs)
	return en_user_profile_danger_zone_subtitle(inputs)
});
export { user_profile_danger_zone_subtitle as "user.profile.danger_zone.subtitle" }